import { GAME_ID, FEEDBACK_TYPES, FeedbackDisplay, ITEMS_TO_MASTER } from '../../data/constants';

const initialState = {
  response: undefined,
  feedbackDisplay: FeedbackDisplay.SUBMIT,
  feedbackType: FEEDBACK_TYPES.NONE,
  correctStandardItems: 0,
  helpIndex: 0,
  answerAttemptCount: 0,
  answeredCorrect: false,
  highestLevelEarned: 0,
  incorrectSelectedIndexes: [],
};

/**
 * The feedbackReducer produces the response from the user's
 * selected Words
 *
 * Quick Refs:
 */
const feedbackReducer = (state = initialState, { gameId, type, payload, stateData }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case 'REQUESTRESPONSE_GAMESTATE': {
      const data = stateData.sloppy_scrolls.GameData;
      if (data === undefined || (data.gameDetails && data.gameDetails.masteredItems === undefined)) {
        return state;
      }
      return {
        ...state,
        highestLevelEarned: data.highestLevelEarned || 0,
      };
    }
    case 'LOAD_NEW_LEVEL': {
      return {
        ...state,
        correctStandardItems: 0,
      };
    }
    case 'SET_FEEDBACK_DISPLAY':
      return {
        ...state,
        feedbackDisplay: payload.feedbackDisplay,
      };
    case 'INCREMENT_HELP_INDEX':
      return {
        ...state,
        helpIndex: state.helpIndex + 1,
      };
    case 'CLEAR_HELP_INDEX':
      return {
        ...state,
        helpIndex: 0,
      };
    case 'INCREMENT_CORRECT_STANDARD':
      return {
        ...state,
        correctStandardItems: state.correctStandardItems + 1,
      };
    case 'INCREMENT_ONBOARDING_INDEX':
    case 'FINISH_SEEING_ONBOARDING':
    case 'INCREMENT_STANDARD_INDEX':
      return {
        ...state,
        response: undefined,
        answerAttemptCount: 0,
        feedbackDisplay: FeedbackDisplay.SUBMIT,
        feedbackType: FEEDBACK_TYPES.NONE,
        incorrectSelectedIndexes: [],
      };
    case 'COMPLETE_ROUND':
      return {
        ...state,
        response: undefined,
        answerAttemptCount: 0,
        feedbackDisplay: FeedbackDisplay.SUBMIT,
        feedbackType: FEEDBACK_TYPES.NONE,
        helpIndex: 0,
        highestLevelEarned: (state.correctStandardItems >= ITEMS_TO_MASTER || payload.forceMastery)
          ? payload.level + 1
          : payload.level,
        incorrectSelectedIndexes: [],
      };
    case 'CLEAR_CORRECT_STANDARD':
      return {
        ...state,
        correctStandardItems: 0,
      };
    case 'SET_FEEDBACK_TYPE': {
      const { feedbackType } = payload;
      const isIncorrectFeedback = [
        FEEDBACK_TYPES.INCORRECT_DID_NOT_FIND_MISTAKE,
        FEEDBACK_TYPES.INCORRECT_FOUND_MISTAKE_WHEN_NONE,
        FEEDBACK_TYPES.INCORRECT_REVEAL,
      ].includes(feedbackType);
      return {
        ...state,
        feedbackType,
        // If user is incorrect, then clear her selected response so she can try again or continue
        response: isIncorrectFeedback ? undefined : state.response,
      };
    }
    case 'SUBMIT_RESPONSE':
      return {
        ...state,
        answerAttemptCount: state.answerAttemptCount + 1,
      };
    case 'TOGGLE_SENTENCE_SELECTION': {
      const response = state.response === payload.sentenceIndex ? undefined : payload.sentenceIndex;
      return {
        ...state,
        response,
      };
    }
    case 'ANSWER_CORRECT':
      return {
        ...state,
        answeredCorrect: true,
      };
    case 'CLEAR_ANSWERED_CORRECT':
      return {
        ...state,
        answeredCorrect: false,
      };
    case 'ADD_INCORRECT_SELECTED_INDEX': {
      const incorrectSelectedIndexes = [...new Set([...state.incorrectSelectedIndexes, payload])];

      return {
        ...state,
        incorrectSelectedIndexes,
      };
    }
    default:
      return state;
  }
};

export default feedbackReducer;
